import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FilterToggleGroup from 'ecosystem-marketplace-core/filters/components/filterToggleGroup';
import Rating from 'ecosystem-marketplace-core/components/reviews/Rating';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
const ALL_RATINGS_VALUE = '__ALL_RATINGS__';

const RatingFilterOptionLabel = ({
  option
}) => {
  const rating = option.value;

  if (rating === ALL_RATINGS_VALUE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.filters.rating.allOptionLabel"
    });
  }

  return /*#__PURE__*/_jsx(Rating, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.filters.rating.optionLabel"
    }),
    rating: rating,
    iconSize: "xxs"
  });
};

let cachedOptions;

const getOptions = () => {
  if (!cachedOptions) {
    cachedOptions = [{
      value: ALL_RATINGS_VALUE
    }, {
      value: 4
    }, {
      value: 3
    }, {
      value: 2
    }, {
      value: 1
    }];
  }

  return cachedOptions;
};

const RatingFilter = ({
  disabled,
  name,
  onChange,
  value
}) => {
  const handleOnChange = useCallback(event => {
    const eventValue = event.target.value;
    const newValue = eventValue === ALL_RATINGS_VALUE ? null : eventValue;
    onChange(ThemeQueryField.MIN_OVERALL_RATING, newValue);
  }, [onChange]);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    disabled: disabled,
    labelComponent: RatingFilterOptionLabel,
    multi: false,
    name: name || ThemeQueryField.MIN_OVERALL_RATING,
    onChange: handleOnChange,
    options: getOptions(),
    value: value || ALL_RATINGS_VALUE
  });
};

export default RatingFilter;